/**
 * Add to Cart Confirmation
 * Spinner from submit until the theme's variant:add / cart:error (theme.js drops aria-busy before its extra cart.js fetch, which flashed the label),
 * then a checkmark over the transparent label for a moment, including the sticky bar's button (linked through the form attribute).
 */
(() => {
  const CONFIRMATION_DURATION = 2000;
  const confirmationTimeouts = new WeakMap();

  const getProductForm = (target) => (target instanceof HTMLFormElement && target.closest("product-form") ? target : null);

  const getSubmitButtons = (productForm) => Array.from(productForm.elements).filter((element) => element.type === "submit");

  const resetButton = (button) => {
    clearTimeout(confirmationTimeouts.get(button));
    confirmationTimeouts.delete(button);
    button.classList.remove("is-loading", "is-added");
    button.querySelector("[data-add-to-cart-confirmation]")?.remove();
  };

  const showConfirmation = (button) => {
    resetButton(button);
    button.classList.add("is-added");
    button.append(document.createRange().createContextualFragment(window.themeVariables.strings.addedToCartConfirmation));
    confirmationTimeouts.set(button, setTimeout(() => resetButton(button), CONFIRMATION_DURATION));
  };

  document.addEventListener("submit", (event) => {
    const productForm = getProductForm(event.target);

    if (!productForm || !productForm.checkValidity()) {
      return;
    }

    getSubmitButtons(productForm).forEach((button) => {
      resetButton(button);
      button.classList.add("is-loading");
    });
  });

  document.addEventListener("variant:add", (event) => {
    const productForm = getProductForm(event.target);

    if (productForm) {
      getSubmitButtons(productForm).forEach(showConfirmation);
    }
  });

  document.addEventListener("cart:error", (event) => {
    const productForm = getProductForm(event.target);

    if (productForm) {
      getSubmitButtons(productForm).forEach(resetButton);
    }
  });
})();
